import CollectPlusLogo from "@JohnLewisPartnership/jl-design-system/dist/assets/third-party/delivery-couriers/collect-plus.svg";
import EvriLogo from "@JohnLewisPartnership/jl-design-system/dist/assets/third-party/delivery-couriers/evri.svg";
import RoyalMailLogo from "@JohnLewisPartnership/jl-design-system/dist/assets/third-party/delivery-couriers/royal-mail.svg";
import BoothsStoreIcon from "@JohnLewisPartnership/jl-design-system/dist/assets/legacy/images/stores/booths-store-icon.svg";
import JLPLogotype from "@JohnLewisPartnership/jl-design-system/dist/assets/john-lewis/john-lewis-and-partners-default.svg";
import WaitroseLogo from "@JohnLewisPartnership/jl-design-system/dist/assets/partnership-brands/waitrose-and-partners-default.svg";
import {
  PrimaryButton,
  SecondaryButton
} from "@JohnLewisPartnership/jl-design-system/dist/elements/button/Button";
import {ChevronRightOutlined as ChevronRight} from "@JohnLewisPartnership/jl-design-system/dist/components/icons/ChevronRightOutlined";
import classnames from "classnames";
import React from "react";
import styles from "./screens.module.scss";

const OptionButton = ({ className, titleClassName, section, title, images, onClick }) => (
  <SecondaryButton
    className={classnames(styles.button, styles.optionButton, styles.checkButton, className)}
    onClick={() => onClick(section)}
  >
    <div className={classnames(styles.optionButton__content, styles.checkButtonContent)}>
      {images && (
        <div className={styles.optionButton__icons}>
          {images.map(img => (
            <img
              key={img.src}
              src={img.src.src}
              alt={img.alt}
              className={styles[img.className]}
            />
          ))}
        </div>
      )}
      <span className={titleClassName}>{title}</span>
    </div>
    <div className={styles.optionButton__chevron}>
      <ChevronRight />
    </div>
  </SecondaryButton>
);

function SolutionCheckStatus({ onGoToContentSection = () => { } }) {
  return (
    <div className={styles.landingPageSolutionContainer}>
      <div className={styles.esiContainer}>
        <div>
          <h4 className={styles.title}>Check the status of your refund</h4>
          <p className={styles.refundSubtitle}>
            You can find out more about your refund and when you can expect to
            get your money back in two ways.
          </p>
          <h6 className={styles.checkTitle}>From your account</h6>
          <p className={styles.textLeft}>
            Check the online order details in your account. When we have
            processed your return, we'll show you the item you returned
            alongside your refund details.
          </p>
          <div
            className={classnames(
              styles.centerWrapper,
              styles.loginButtonWrapper
            )}
          >
            <PrimaryButton
              tag="a"
              href="https://account.johnlewis.com/orders"
              className={styles.button}
            >
              Sign in now
            </PrimaryButton>
          </div>
          <div className={styles.dividerWithText}>OR</div>
          <div className={styles.orSection}>
            <h6 className={styles.checkTitle}>
              From your confirmation email
            </h6>
            <p className={styles.textLeft}>
              We sent you a confirmation email when you placed your order. If
              you weren't signed-in while ordering, use the links in your
              confirmation email.
            </p>
          </div>
          <div className={styles.dividerWithText} />
        </div>
        <div>
          <div className={styles.orSection}>
            <div className={styles.checkTitle}>
              How long will a refund take?
            </div>
            <p className={styles.textLeft}>
              This varies and depends on how you choose to return the item.
              Below are our return options, click one to find out more.
            </p>
            <div className={styles.containerRow}>
              <OptionButton
                className={styles.spaceRight}
                titleClassName={styles.spaceTop}
                section="refundJohnLewis"
                title="Returned item in-store at John Lewis & Partners"
                images={[
                  { src: JLPLogotype, alt: "John Lewis", className: "royalMailLogoSmall" },
                ]}
                onClick={onGoToContentSection}
              />
              <OptionButton
                titleClassName={styles.spaceTop}
                section="refundWaitrose"
                title="Returned item in-store at Waitrose"
                images={[
                  { src: WaitroseLogo, alt: "Waitrose", className: "royalMailLogoSmall" },
                ]}
                onClick={onGoToContentSection}
              />
            </div>
            <div className={styles.containerRow}>
              <OptionButton
                className={styles.spaceRight}
                titleClassName={styles.spaceTop}
                section="refundRoyalMailCollectPlusEvri"
                title="Returned by Royal Mail, Collect+ or Evri"
                images={[
                  { src: RoyalMailLogo, alt: "Royal Mail", className: "royalMailLogoSmall" },
                  {
                    src: CollectPlusLogo,
                    alt: "Collect+",
                    className: "collectPlusLogoSmall"
                  },
                  { src: EvriLogo, alt: "Evri", className: "evriLogoSmall" }
                ]}
                onClick={onGoToContentSection}
              />
              <OptionButton
                titleClassName={styles.spaceTop}
                section="refundBooths"
                title="Returned item to a Booths location with Click and Collect"
                images={[
                  {
                    src: BoothsStoreIcon,
                    alt: "Booths",
                    className: "boothsLogo"
                  },
                ]}
                onClick={onGoToContentSection}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default SolutionCheckStatus;
